import { redemptionService } from '../redemptionService/redemptionService.js';

/* eslint-disable no-restricted-syntax */
/**
 * Proxy for localStorage
 *
 * Centralizes all localStorage operations
 *
 * Additionally leveraged to support *redemptionCartID* management via *cartID* (Project Fusion)
 */
class LocalStorageProxy {
    /**
     * Singleton pattern
     *
     * @param {RedemptionServiceType} redemptionService - RedemptionService instance
     */
    constructor(redemptionService) {
        this.redemptionService = redemptionService;
    }
    static getInstance(redemptionService) {
        if (!LocalStorageProxy.instance) {
            if (redemptionService) {
                LocalStorageProxy.instance = new LocalStorageProxy(redemptionService);
            }
            else {
                throw new Error('RedemptionService is required for LocalStorageProxy');
            }
        }
        return LocalStorageProxy.instance;
    }
    /**
     * SET item in localStorage
     *
     * @param {string} key - key to set in localStorage
     * @param {string} value - value to set in localStorage
     */
    setItem(key, value) {
        try {
            this.initialInterceptor(key);
            const update = this.redemptionService.handleSetItemArgs(key, value);
            if (update === null || update === void 0 ? void 0 : update.key)
                key = update.key;
            if (update === null || update === void 0 ? void 0 : update.value)
                value = update.value;
            localStorage.setItem(key, value);
        }
        catch (e) {
            console.error('Error setting item in localStorage', e);
        }
    }
    /**
     * GET item from localStorage
     *
     * @param {string} key - key to get from localStorage
     * @returns {string}
     */
    getItem(key) {
        try {
            this.initialInterceptor(key);
            const update = this.redemptionService.handleGetItemArgs(key);
            if (update === null || update === void 0 ? void 0 : update.key)
                key = update.key;
            return localStorage.getItem(key);
        }
        catch (e) {
            console.error('Error getting item from localStorage', e);
        }
        return null;
    }
    /**
     * REMOVE item from localStorage
     *
     * @param {string} key - key to remove from localStorage
     */
    removeItem(key) {
        try {
            this.initialInterceptor(key);
            const update = this.redemptionService.handleRemoveItemArgs(key);
            if (update === null || update === void 0 ? void 0 : update.key)
                key = update.key;
            localStorage.removeItem(key);
        }
        catch (e) {
            console.error('Error removing item from localStorage', e);
        }
    }
    /**
     * CLEAR all items from localStorage
     */
    clear() {
        try {
            this.initialInterceptor('');
            localStorage.clear();
        }
        catch (e) {
            console.error('Error clearing localStorage', e);
        }
    }
    /**
     * Interceptor for ALL localStorage operations
     *
     * ! Must use native localStorage methods within the interceptor otherwise it will cause an infinite loop
     *
     * @param {string} key - key to check for redemption scenario
     */
    initialInterceptor(key) {
        this.redemptionService.checkCleanup(key);
    }
}
const localStorageProxy = LocalStorageProxy.getInstance(redemptionService);

export { localStorageProxy };
//# sourceMappingURL=localStorageProxy.js.map
